// Vendor imports
const qs = require('qs')
// Client V1 imports
const Analytics = require('client/lib/analytics')
// Common V2 imports
const { render } = require('client-v2/common/client')
// Entry imports
const configureStore = require('./state/store')
const rootFactory = require('./components/root').factory
const { showArticleProfileModal } = require('./containers/feed/actions')

render(configureStore, rootFactory)

const initialState = app.store.getState()

const analyticsPageActions = {
  'search.showDomainPosts': 'posts',
  'search.showQueryCollections': 'mixes',
  'search.showQueryInterests': 'interests',
  'search.showQueryPeople': 'mixes',
  'search.showQueryPosts': 'posts'
}
const pageAction = analyticsPageActions[initialState.router.action]

Analytics.setPageContext({
  pageName: `search.${pageAction}`
})
Analytics.track('pageview')

const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true })
if (pageAction === 'posts' && queryParams.modal) {
  app.store.dispatch(showArticleProfileModal())
}
